/* ================= TRANSFER CONSTANTS ================= */
/* ================= TRANSFER CONSTANTS ================= */

/* ---------- ALPHABET ---------- */
export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

/* ---------- DISTRICTS ---------- */
export const DISTRICTS = [
  "1010","1020","1030","1040","1050","1060","1070","1080","1090",
  "1100","1110","1120","1130","1140","1150","1160","1170",
  "1180","1190","1200","1210","1210","1220","1230"
];

/* ---------- AIRPORT ---------- */
export const AIRPORT_LAT_LNG = [48.1103, 16.5697];
export const AIRPORT_NAME = "Vienna International Airport";

/* ---------- APP LINKS ---------- */
export const APPLE_LINK =
  "https://apps.apple.com/at/app/ryyd-taxi-buchen-in-wien/id6756548235";

export const PLAY_LINK =
  "https://play.google.com/store/apps/details?id=com.taxi.ryyd";

/* ---------- POPULAR ATTRACTIONS ---------- */
export const POPULAR_ATTRACTIONS = [
  {
    slug: "schonbrunn-palace",
    name: "Schönbrunn Palace",
    address: "Schönbrunner Schlossstraße 47, 1130 Vienna, Austria",
    lat: 48.184517,
    lng: 16.311865
  },
  {
    slug: "st-stephens-cathedral",
    name: "St. Stephen's Cathedral",
    address: "Stephansplatz 3, 1010 Vienna, Austria",
    lat: 48.208174,
    lng: 16.373819
  },
  {
    slug: "hofburg-palace",
    name: "Hofburg Palace",
    address: "Heldenplatz, 1010 Vienna, Austria",
    lat: 48.206217,
    lng: 16.36629
  },
  {
    slug: "belvedere-palace",
    name: "Belvedere Palace",
    address: "Prinz-Eugen-Straße 27, 1030 Vienna, Austria",
    lat: 48.191104,
    lng: 16.380664
  },
  {
    slug: "vienna-giant-ferris-wheel",
    name: "Vienna Giant Ferris Wheel (Wiener Riesenrad)",
    address: "Riesenradplatz 1, 1020 Vienna, Austria",
    lat: 48.216667,
    lng: 16.4
  },
  {
    slug: "vienna-state-opera",
    name: "Vienna State Opera",
    address: "Opernring 2, 1010 Vienna, Austria",
    lat: 48.202167,
    lng: 16.36837
  },
  {
    slug: "kunsthistorisches-museum",
    name: "Kunsthistorisches Museum Vienna",
    address: "Maria-Theresien-Platz, 1010 Vienna, Austria",
    lat: 48.2035,
    lng: 16.3632
  },
  {
    slug: "museumquartier",
    name: "MuseumsQuartier Vienna",
    address: "Museumsplatz 1, 1070 Vienna, Austria",
    lat: 48.203889,
    lng: 16.359167
  },
  {
    slug: "vienna-central-station",
    name: "Vienna Central Station (Hauptbahnhof)",
    address: "Am Hauptbahnhof 1, 1100 Vienna, Austria",
    lat: 48.1850,
    lng: 16.3745
  },
  {
    slug: "vienna-international-airport",
    name: "Vienna International Airport",
    address: "Flughafen Wien, 1300 Schwechat, Austria",
    lat: 48.1103,
    lng: 16.5697
  },
  {
    slug: "vienna-westbahnhof",
  name: "Vienna Westbahnhof",
  address: "Europaplatz 2, 1150 Vienna, Austria",
  lat: 48.1966,
  lng: 16.3379
  }
];

export const UI_TEXT = {
  nearbyPlaces: {
    en: "Nearby places",
    de: "Sehenswürdigkeiten in der Nähe",
    es: "Lugares cercanos",
    it: "Luoghi nelle vicinanze",
    nl: "Bezienswaardigheden in de buurt",
    pl: "Miejsca w pobliżu",
    pt: "Locais próximos",
    ro: "Locuri din apropiere",
    hu: "Közeli helyek",
    cs: "Místa v okolí",
    sk: "Miesta v okolí",
    sl: "Kraji v bližini",
    uk: "Місця поблизу",
    bg: "Места наблизо",
    tr: "Yakındaki yerler",
    ja: "近くの観光地",
    ko: "근처 명소",
    hi: "नज़दीकी स्थान",
    ar: "أماكن قريبة",
    th: "สถานที่ใกล้เคียง",
    vi: "Địa điểm gần đây",
    fr: "Lieux à proximité",
    el: "Κοντινά σημεία",
    sr: "Mjesta u blizini"
  },

  priceHint: {
    en: "Download the Ryyd app to see the exact taxi price",
    de: "Lade die Ryyd App herunter, um den genauen Taxipreis zu sehen",
    es: "Descarga la app Ryyd para ver el precio exacto del taxi",
    it: "Scarica l’app Ryyd per vedere il prezzo esatto del taxi",
    nl: "Download de Ryyd-app om de exacte taxiprijs te zien",
    pl: "Pobierz aplikację Ryyd, aby zobaczyć dokładną cenę taksówki",
    pt: "Baixe o app Ryyd para ver o preço exato do táxi",
    ro: "Descarcă aplicația Ryyd pentru a vedea prețul exact al taxiului",
    hu: "Töltsd le a Ryyd alkalmazást a pontos taxidíj megtekintéséhez",
    cs: "Stáhněte si aplikaci Ryyd a zobrazte přesnou cenu taxi",
    sk: "Stiahnite si aplikáciu Ryyd a zobrazte presnú cenu taxíka",
    sl: "Prenesite aplikacijo Ryyd za natančno ceno taksija",
    uk: "Завантажте додаток Ryyd, щоб побачити точну ціну таксі",
    bg: "Изтеглете приложението Ryyd, за да видите точната цена на таксито",
    tr: "Kesin taksi fiyatını görmek için Ryyd uygulamasını indirin",
    ja: "正確なタクシー料金を見るにはRyydアプリをダウンロードしてください",
    ko: "정확한 택시 요금을 보려면 Ryyd 앱을 다운로드하세요",
    hi: "सटीक टैक्सी कीमत देखने के लिए Ryyd ऐप डाउनलोड करें",
    ar: "حمّل تطبيق Ryyd لمعرفة سعر التاكسي بدقة",
    th: "ดาวน์โหลดแอป Ryyd เพื่อดูราคารถแท็กซี่ที่แน่นอน",
    vi: "Tải ứng dụng Ryyd để xem giá taxi chính xác",
    fr: "Téléchargez l’application Ryyd pour voir le prix exact du taxi",
    el: "Κατεβάστε την εφαρμογή Ryyd για να δείτε την ακριβή τιμή ταξί",
    sr: "Preuzmite Ryyd aplikaciju da biste vidjeli tačnu cijenu taksija"
  },

  popularFromHotel: {
    en: "Popular destinations near",
    de: "Beliebte Reiseziele nahe",
    es: "Destinos populares cerca de",
    it: "Destinazioni popolari vicino a",
    nl: "Populaire bestemmingen nabij",
    pl: "Popularne miejsca w pobliżu",
    pt: "Destinos populares perto de",
    ro: "Destinații populare lângă",
    hu: "Népszerű úti célok a közelben",
    cs: "Oblíbené destinace poblíž",
    sk: "Obľúbené destinácie v blízkosti",
    sl: "Priljubljene destinacije v bližini",
    uk: "Популярні напрямки поруч з",
    bg: "Популярни дестинации близо до",
    tr: "Yakındaki popüler destinasyonlar",
    ja: "近くの人気スポット",
    ko: "근처 인기 목적지",
    hi: "पास के लोकप्रिय गंतव्य",
    ar: "وجهات شهيرة بالقرب من",
    th: "สถานที่ยอดนิยมใกล้",
    vi: "Điểm đến phổ biến gần",
    fr: "Destinations populaires près de",
    el: "Δημοφιλείς προορισμοί κοντά σε",
    sr: "Popularne destinacije blizu"
  },

  taxiFrom: {
    en: "Taxi from",
    de: "Taxi von",
    es: "Taxi desde",
    it: "Taxi da",
    nl: "Taxi van",
    pl: "Taxi z",
    pt: "Táxi de",
    ro: "Taxi de la",
    hu: "Taxi innen",
    cs: "Taxi z",
    sk: "Taxi z",
    sl: "Taxi iz",
    uk: "Таксі з",
    bg: "Такси от",
    tr: "Taksi",
    ja: "タクシー",
    ko: "택시",
    hi: "टैक्सी",
    ar: "تاكسي من",
    th: "แท็กซี่จาก",
    vi: "Taxi từ",
    fr: "Taxi depuis",
    el: "Ταξί από",
    sr: "Taksi od"
  },

  taxiTo: {
    en: "to",
    de: "nach",
    es: "a",
    it: "a",
    nl: "naar",
    pl: "do",
    pt: "para",
    ro: "către",
    hu: "ide",
    cs: "do",
    sk: "do",
    sl: "do",
    uk: "до",
    bg: "до",
    tr: "→",
    ja: "まで",
    ko: "까지",
    hi: "तक",
    ar: "إلى",
    th: "ไปยัง",
    vi: "đến",
    fr: "vers",
    el: "προς",
    sr: "do"
  },moreHotelsDistrict: {
    en: "More hotels in district",
    de: "Weitere Hotels im Bezirk",
    es: "Más hoteles en el distrito",
    it: "Altri hotel nel distretto",
    nl: "Meer hotels in de wijk",
    pl: "Więcej hoteli w dzielnicy",
    pt: "Mais hotéis no distrito",
    ro: "Mai multe hoteluri în district",
    hu: "További szállodák a kerületben",
    cs: "Další hotely v okrese",
    sk: "Ďalšie hotely v okrese",
    sl: "Več hotelov v okrožju",
    uk: "Більше готелів у районі",
    bg: "Още хотели в района",
    tr: "Bölgedeki diğer oteller",
    ja: "同じ地区の他のホテル",
    ko: "해당 지역의 다른 호텔",
    hi: "इस ज़िले में और होटल",
    ar: "فنادق أخرى في المنطقة",
    th: "โรงแรมเพิ่มเติมในเขตนี้",
    vi: "Thêm khách sạn trong quận",
    fr: "Plus d’hôtels dans le district",
    el: "Περισσότερα ξενοδοχεία στην περιοχή",
    sr: "Više hotela u okrugu"
  }
};

/* ---------- LANGUAGES ---------- */
export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "ro", label: "Română", flag: "🇷🇴" },
  { code: "hu", label: "Magyar", flag: "🇭🇺" },
  { code: "cs", label: "Čeština", flag: "🇨🇿" },
  { code: "sk", label: "Slovenčina", flag: "🇸🇰" },
  { code: "sl", label: "Slovenščina", flag: "🇸🇮" },
  { code: "uk", label: "Українська", flag: "🇺🇦" },
  { code: "bg", label: "Български", flag: "🇧🇬" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "ar", label: "العربية", flag: "🇦🇪" },
  { code: "th", label: "ไทย", flag: "🇹🇭" },
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "el", label: "Ελληνικά", flag: "🇬🇷" },
  { code: "sr", label: "Srpski / Hrvatski / Bosanski", flag: "🇷🇸" }
];

/* ---------- AIRPORT TRANSLATIONS ---------- */
export const AIRPORT_TRANSLATIONS = {
  en: "Vienna International Airport (Schwechat)",
  de: "Flughafen Wien (Schwechat)",
  es: "Aeropuerto Internacional de Viena (Schwechat)",
  it: "Aeroporto Internazionale di Vienna (Schwechat)",
  nl: "Internationale Luchthaven Wenen (Schwechat)",
  pl: "Lotnisko Wiedeń-Schwechat",
  pt: "Aeroporto Internacional de Viena (Schwechat)",
  ro: "Aeroportul Internațional Viena (Schwechat)",
  hu: "Bécs Nemzetközi Repülőtér (Schwechat)",
  cs: "Letiště Vídeň (Schwechat)",
  sk: "Letisko Viedeň (Schwechat)",
  sl: "Letališče Dunaj (Schwechat)",
  uk: "Віденський міжнародний аеропорт (Швехат)",
  bg: "Летище Виена (Швехат)",
  tr: "Viyana Uluslararası Havalimanı (Schwechat)",
  ja: "ウィーン国際空港（シュヴェヒャート）",
  ko: "비엔나 국제공항(슈베하트)",
  hi: "वियना अंतरराष्ट्रीय हवाई अड्डा (श्वेखाट)",
  ar: "مطار فيينا الدولي (شفخات)",
  th: "สนามบินนานาชาติเวียนนา (ชเวฮัท)",
  vi: "Sân bay Quốc tế Vienna (Schwechat)",
  fr: "Aéroport international de Vienne (Schwechat)",
  el: "Διεθνές Αεροδρόμιο Βιέννης (Σβέχατ)",
  sr: "Međunarodni aerodrom Beč (Schwechat)"
};



/* ================= TRANSLATIONS ================= */
export const TRANSLATIONS = {
  en: {
    from: "Taxi Transfer from",
    to: "to",
    overview: "Taxi Transfers in Vienna",
    districts: "Districts",
    distance: "Distance",
    duration: "Duration",
    price: "Taxi price",
    checkPrice: "Check price in the Ryyd Taxi App",
    book: "Book your taxi in seconds",
    moreDistrict: "More hotels in district"
  },

  de: {
    from: "Taxi Transfer von",
    to: "nach",
    overview: "Taxi Transfers in Wien",
    districts: "Bezirke",
    distance: "Entfernung",
    duration: "Dauer",
    price: "Taxipreis",
    checkPrice: "Preis in der Ryyd Taxi App ansehen",
    book: "Ryyd - Taxi in Sekunden buchen",
    moreDistrict: "Weitere Hotels im Bezirk"
  },

  es: {
    from: "Taxi desde",
    to: "hasta",
    overview: "Traslados en taxi en Viena",
    districts: "Distritos",
    distance: "Distancia",
    duration: "Duración",
    price: "Precio del taxi",
    checkPrice: "Ver precio en la app Ryyd",
    book: "Ryyd - Reserva tu taxi en segundos",
    moreDistrict: "Más hoteles en el distrito"
  },

  it: {
    from: "Taxi da",
    to: "a",
    overview: "Trasferimenti taxi a Vienna",
    districts: "Distretti",
    distance: "Distanza",
    duration: "Durata",
    price: "Prezzo del taxi",
    checkPrice: "Controlla il prezzo nell’app Ryyd",
    book: "Ryyd - Prenota il tuo taxi in pochi secondi",
    moreDistrict: "Altri hotel nel distretto"
  },

  nl: {
    from: "Taxi van",
    to: "naar",
    overview: "Taxi transfers in Wenen",
    districts: "Districten",
    distance: "Afstand",
    duration: "Duur",
    price: "Taxiprijs",
    checkPrice: "Bekijk prijs in de Ryyd Taxi App",
    book: "Ryyd - Boek je taxi in seconden",
    moreDistrict: "Meer hotels in de wijk"
  },

  pl: {
    from: "Taksówka z",
    to: "do",
    overview: "Transfery taxi w Wiedniu",
    districts: "Dzielnice",
    distance: "Odległość",
    duration: "Czas trwania",
    price: "Cena taxi",
    checkPrice: "Sprawdź cenę w aplikacji Ryyd",
    book: "Ryyd - Zarezerwuj taxi w kilka sekund",
    moreDistrict: "Więcej hoteli w dzielnicy"
  },

  pt: {
    from: "Táxi de",
    to: "para",
    overview: "Transfers de táxi em Viena",
    districts: "Distritos",
    distance: "Distância",
    duration: "Duração",
    price: "Preço do táxi",
    checkPrice: "Ver preço no app Ryyd",
    book: "Ryyd - Reserve seu táxi em segundos",
    moreDistrict: "Mais hotéis no distrito"
  },

  ro: {
    from: "Taxi de la",
    to: "către",
    overview: "Transferuri taxi în Viena",
    districts: "Districte",
    distance: "Distanță",
    duration: "Durată",
    price: "Preț taxi",
    checkPrice: "Vezi prețul în aplicația Ryyd",
    book: "Ryyd - Rezervă taxiul în câteva secunde",
    moreDistrict: "Mai multe hoteluri în district"
  },

  hu: {
    from: "Taxi innen",
    to: "ide",
    overview: "Taxi transzferek Bécsben",
    districts: "Kerületek",
    distance: "Távolság",
    duration: "Időtartam",
    price: "Taxi ára",
    checkPrice: "Ár megtekintése a Ryyd alkalmazásban",
    book: "Ryyd - Foglalj taxit másodpercek alatt",
    moreDistrict: "További szállodák a kerületben"
  },

  cs: {
    from: "Taxi z",
    to: "do",
    overview: "Taxi transfery ve Vídni",
    districts: "Čtvrti",
    distance: "Vzdálenost",
    duration: "Doba trvání",
    price: "Cena taxi",
    checkPrice: "Zobrazit cenu v aplikaci Ryyd",
    book: "Ryyd - Objednejte si taxi během několika sekund",
    moreDistrict: "Další hotely v okrese"
  },

  sk: {
    from: "Taxi z",
    to: "do",
    overview: "Taxi transfery vo Viedni",
    districts: "Okresy",
    distance: "Vzdialenosť",
    duration: "Trvanie",
    price: "Cena taxi",
    checkPrice: "Zobraziť cenu v aplikácii Ryyd",
    book: "Ryyd - Objednajte si taxi za pár sekúnd",
    moreDistrict: "Ďalšie hotely v okrese"
  },

  sl: {
    from: "Taxi iz",
    to: "do",
    overview: "Taxi prevozi na Dunaju",
    districts: "Okrožja",
    distance: "Razdalja",
    duration: "Trajanje",
    price: "Cena taksija",
    checkPrice: "Preveri ceno v aplikaciji Ryyd",
    book: "Ryyd - Rezervirajte taksi v nekaj sekundah",
    moreDistrict: "Več hotelov v okrožju"
  },

  uk: {
    from: "Таксі з",
    to: "до",
    overview: "Таксі трансфери у Відні",
    districts: "Райони",
    distance: "Відстань",
    duration: "Тривалість",
    price: "Ціна таксі",
    checkPrice: "Переглянути ціну в додатку Ryyd",
    book: "Ryyd - Замовте таксі за секунди",
    moreDistrict: "Більше готелів у районі"
  },

  bg: {
    from: "Такси от",
    to: "до",
    overview: "Такси трансфери във Виена",
    districts: "Райони",
    distance: "Разстояние",
    duration: "Продължителност",
    price: "Цена на такси",
    checkPrice: "Виж цената в приложението Ryyd",
    book: "Ryyd - Резервирайте такси за секунди",
    moreDistrict: "Още хотели в района"
  },

  tr: {
    from: "Taksi",
    to: "'dan",
    overview: "Viyana Taksi Transferleri",
    districts: "Bölgeler",
    distance: "Mesafe",
    duration: "Süre",
    price: "Taksi ücreti",
    checkPrice: "Ryyd uygulamasında fiyatı gör",
    book: "Ryyd - Saniyeler içinde taksi çağır",
    moreDistrict: "Bu bölgedeki diğer oteller"
  },

  ja: {
    from: "タクシー",
    to: "まで",
    overview: "ウィーンのタクシー送迎",
    districts: "地区",
    distance: "距離",
    duration: "所要時間",
    price: "タクシー料金",
    checkPrice: "Ryydアプリで料金を見る",
    book: "Ryyd - 数秒でタクシーを予約",
    moreDistrict: "同じ地区の他のホテル"
  },

  ko: {
    from: "택시",
    to: "까지",
    overview: "비엔나 택시 이동",
    districts: "지역",
    distance: "거리",
    duration: "소요 시간",
    price: "택시 요금",
    checkPrice: "Ryyd 앱에서 요금 확인",
    book: "Ryyd - 몇 초 만에 택시 예약",
    moreDistrict: "해당 지역의 다른 호텔"
  },

  hi: {
    from: "टैक्सी",
    to: "तक",
    overview: "वियना टैक्सी ट्रांसफर",
    districts: "ज़िले",
    distance: "दूरी",
    duration: "समय",
    price: "टैक्सी किराया",
    checkPrice: "Ryyd ऐप में कीमत देखें",
    book: "Ryyd - सेकंड में टैक्सी बुक करें",
    moreDistrict: "इस ज़िले में और होटल"
  },

  ar: {
    from: "تاكسي من",
    to: "إلى",
    overview: "خدمات تاكسي في فيينا",
    districts: "المناطق",
    distance: "المسافة",
    duration: "المدة",
    price: "سعر التاكسي",
    checkPrice: "تحقق من السعر في تطبيق Ryyd",
    book: "Ryyd - احجز التاكسي خلال ثوانٍ",
    moreDistrict: "فنادق أخرى في المنطقة"
  },

  th: {
    from: "แท็กซี่จาก",
    to: "ไปยัง",
    overview: "บริการแท็กซี่ในเวียนนา",
    districts: "เขต",
    distance: "ระยะทาง",
    duration: "ระยะเวลา",
    price: "ค่าแท็กซี่",
    checkPrice: "ดูราคาในแอป Ryyd",
    book: "Ryyd - จองแท็กซี่ในไม่กี่วินาที",
    moreDistrict: "โรงแรมเพิ่มเติมในเขตนี้"
  },

  vi: {
    from: "Taxi từ",
    to: "đến",
    overview: "Dịch vụ taxi tại Vienna",
    districts: "Quận",
    distance: "Khoảng cách",
    duration: "Thời gian",
    price: "Giá taxi",
    checkPrice: "Xem giá trong ứng dụng Ryyd",
    book: "Ryyd - Đặt taxi trong vài giây",
    moreDistrict: "Thêm khách sạn trong quận"
  },
  fr: {
    from: "Taxi de",
    to: "vers",
    overview: "Transferts en taxi à Vienne",
    districts: "Districts",
    distance: "Distance",
    duration: "Durée",
    price: "Prix du taxi",
    checkPrice: "Voir le prix dans l’application Ryyd",
    book: "Ryyd - Réservez votre taxi en quelques secondes",
    moreDistrict: "Plus d’hôtels dans le district"
  },
  el: {
    from: "Ταξί από",
    to: "προς",
    overview: "Μεταφορές ταξί στη Βιέννη",
    districts: "Περιοχές",
    distance: "Απόσταση",
    duration: "Διάρκεια",
    price: "Τιμή ταξί",
    checkPrice: "Δείτε την τιμή στην εφαρμογή Ryyd",
    book: "Ryyd - Κλείστε ταξί σε δευτερόλεπτα",
    moreDistrict: "Περισσότερα ξενοδοχεία στην περιοχή"
  },
  sr: {
    from: "Taksi od",
    to: "do",
    overview: "Taxi transferi u Beču",
    districts: "Općine",
    distance: "Udaljenost",
    duration: "Trajanje",
    price: "Cijena taksija",
    checkPrice: "Provjerite cijenu u Ryyd aplikaciji",
    book: "Ryyd - Rezervišite taksi za nekoliko sekundi",
    moreDistrict: "Više hotela u okrugu"
  }
};
